import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_CreateParticipantDialog = _resolveComponent("CreateParticipantDialog")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            flat: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, {
                color: "secondary",
                extended: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: "/",
                    custom: ""
                  }, {
                    default: _withCtx(({navigate}) => [
                      _createVNode(_component_v_btn, {
                        onClick: navigate,
                        icon: "",
                        class: "text-white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                              _createTextVNode("mdi-arrow-left-circle", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_toolbar_title, { class: "text-white pageHeader" }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("Participant Search", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                class: "mx-auto",
                "max-width": "100%",
                style: {"margin-top":"-60px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchValidationResults, (result, index) => {
                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                          class: "error",
                                          key: index
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(result), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchOptions, (option) => {
                                return (_openBlock(), _createBlock(_component_v_col, {
                                  cols: "12",
                                  md: "4",
                                  lg: "3",
                                  key: option.key
                                }, {
                                  default: _withCtx(() => [
                                    (option.type == 'select')
                                      ? (_openBlock(), _createBlock(_component_v_select, {
                                          key: 0,
                                          multiple: "",
                                          items: _ctx.getLookupList(option.lookupKey),
                                          "item-value": "id",
                                          "item-title": "description",
                                          modelValue: _ctx.searchDto[option.key],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.searchDto[option.key]) = $event),
                                          label: option.name,
                                          onKeyup: _withKeys(_ctx.getParticipantResults, ["enter"])
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue", "label", "onKeyup"]))
                                      : (_openBlock(), _createBlock(_component_v_text_field, {
                                          key: 1,
                                          modelValue: _ctx.searchDto[option.key],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.searchDto[option.key]) = $event),
                                          label: option.name,
                                          type: option.type,
                                          "hide-details": "",
                                          color: "white",
                                          onKeyup: _withKeys(_ctx.getParticipantResults, ["enter"])
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "type", "onKeyup"]))
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { align: "center" }, {
                                default: _withCtx(() => [
                                  _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    color: "info",
                                    onClick: _ctx.getParticipantResults
                                  }, {
                                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                      _createTextVNode("Search", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["onClick"])), [
                                    [_directive_ripple]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.canEditRolePermission)
                        ? (_openBlock(), _createBlock(_component_v_card_title, {
                            key: 0,
                            class: "mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { justify: "end" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { align: "right" }, {
                                    default: _withCtx(() => [
                                      _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                        class: "ma-2",
                                        onClick: _ctx.togglePartCreateDialog
                                      }, {
                                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                          _createTextVNode(" Create Participant ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["onClick"])), [
                                        [_directive_ripple]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CreateParticipantDialog, {
                    dialog: _ctx.isCreateParticipantDialogActive,
                    "retain-focus": false,
                    onCloseParticipantDialog: _ctx.togglePartCreateDialog,
                    onNewParticipantSubmit: _ctx.newParticipantSubmit,
                    ref: "createPartDialog"
                  }, null, 8, ["dialog", "onCloseParticipantDialog", "onNewParticipantSubmit"]),
                  (_ctx.isLoadingResults)
                    ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_data_table, {
                            headers: _ctx.participantHeaders,
                            items: _ctx.searchResults,
                            density: "compact",
                            class: "elevation-1"
                          }, {
                            "item.actions": _withCtx(({ item }) => [
                              _createVNode(_component_v_btn, {
                                onClick: ($event: any) => (_ctx.openParticipantDetail(item)),
                                density: "comfortable",
                                size: "small",
                                icon: "mdi-magnify-plus-outline",
                                color: "info"
                              }, null, 8, ["onClick"])
                            ]),
                            "no-data": _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", {
                                  colspan: "7",
                                  class: "text-center"
                                }, "No results available.")
                              ], -1)
                            ]))]),
                            _: 1
                          }, 8, ["headers", "items"])
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}